// extracted by mini-css-extract-plugin
export default {"component":"LTUKSn","mobile":"fQsGct","heading":"CdZq08","label":"tTd2Lx","inputWrap":"sl8IDN","input":"uXrMW1","buttonWrapper":"b9hckr","agreement":"l6Ad9B","description":"isGBeS"};